var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',[_c('b-container',[_c('div',{staticClass:"d-flex flex-wrap"},[_c('iframe',{attrs:{"src":"https://www.youtube.com/embed/z5uUBzeo0XU","frameborder":"0","allow":"accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture","allowfullscreen":""}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }